<app-status-sidebar
  [itemId]="requestId()"
  [config]="requestConfig"
  [service]="requestService"
  [updateMethod]="'updateRequest'"
  [getDetailsMethod]="'getSingleRequest'"
></app-status-sidebar>
